import React from 'react';

import styled from 'styled-components';

import { mobile, desktop } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const PreSignin = styled.span`
  font-weight: 600;
  ${mobile`display: none;`}
`;

const SignInCopy = styled.span`
  ${mobile`
		text-transform: uppercase;
	`}

  ${desktop`
	  font-weight: bold;
	  text-decoration: underline;
    cursor: pointer;
	`}
`;

export default function LoginLabel() {
  return (
    <>
      <PreSignin>
        <FormattedMessage
          id="site_navigation.201512_toplevel_already_member"
          defaultMessage="Already a member?"
        />
      </PreSignin>{' '}
      <SignInCopy>
        <FormattedMessage
          id="site_navigation.201512_toplevel_signin"
          defaultMessage="Sign In"
        />
      </SignInCopy>
    </>
  );
}
